import React, { useEffect } from 'react';
import styled from 'styled-components';
import ContactEdit from '../../../images/ContactEdit.svg';
import ContactRemove from '../../../images/ContactRemove.svg';
import { setContactActive } from '../../../services';

const DetailsContainer = styled.div`
  display: flex;
  align-self: center;
  justify-content: space-between;
  width: 90%;
  background: #f0f3f6;
  border: 1.5px solid #f0f3f6;
  border-radius: 12px;
  margin-top: 5px;
  padding: 12px;
`;

const Active = styled.div`
  height: 22px;
  width: 22px;
  border-radius: 100%;
  cursor: pointer;
x  display: flex;
  align-self: center;
`;

const InfoContainer = styled.div``;

const InfoTextContainer = styled.div``;

const InfoText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #0f0b28;
`;

const Info = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
  color: #585969;
`;

const ImgContainer = styled.div`
  display: flex;
  gap: 4px;
`;

const Img = styled.img`
  height: 32px;
  width: 32px;
  cursor: pointer;
`;

const ContactCard = (props) => {
  return (
    <DetailsContainer>
      <div className="flex items-center gap-10px">
        <Active
          onClick={() => props.handleActive(props)}
          style={
            props.contact.contactId === props.activeContact
              ? { background: 'var(--primary-button)' }
              : { background: '#E3E3E3' }
          }
        />
        <InfoContainer>
          <InfoTextContainer>
            <InfoText>{props.contact.name}</InfoText>
          </InfoTextContainer>
          <Info>{props.contact.emergencyContact}</Info>
        </InfoContainer>
      </div>
      <ImgContainer>
        <Img
          src={ContactEdit}
          onClick={() =>
            props.handleEdit(props.contact.contactId, props.contact)
          }
        />
        <Img src={ContactRemove} onClick={() => props.handleDelete(props)} />
      </ImgContainer>
    </DetailsContainer>
  );
};

export default ContactCard;
